var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityFill = function SvgSecurityFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#security-fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5c7f"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.867 1.238-2.27-1.01a2.618 2.618 0 0 0-2.141 0C9.77.98 6.026 2.644 4.069 3.513A2.647 2.647 0 0 0 2.5 5.925v8.13c0 3.259 1.803 5.574 3.893 7.152 2.034 1.536 4.33 2.357 5.396 2.686h.004l.006.005c.474.136.976.136 1.455 0 .005 0 .005 0 .01-.005 1.066-.329 3.362-1.15 5.396-2.686 2.09-1.578 3.893-3.898 3.893-7.152v-8.13a2.647 2.647 0 0 0-1.569-2.413c-1.298-.575-3.374-1.498-5.117-2.274ZM12.564 7a.95.95 0 0 0-.254 1.86l-1.99 3.447-1.969-1.611a.949.949 0 1 0-.4.225l.78 3.931c.048.211.231.357.447.357h6.762c.217 0 .4-.146.447-.357l.77-3.893a.949.949 0 1 0-.474-.197L14.85 12.26l-1.972-3.414A.95.95 0 0 0 12.564 7Z",
    fill: "#FF5C7F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "security-fill_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSecurityFill;